import { useEffect } from "react";
import Farmer from '../table/Tablefarmer';
import Modal from "../modal/Modaladdfarmer"
import Modalfarmer from "../modal/Importfarmer"
import ImportFarmerPhotos from "../modal/ImportFarmerPhotos"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <div style={{display:"flex", flexWrap:"wrap", gap:8, alignItems:"center"}}>
      <Modal/>
      <Modalfarmer />
      <ImportFarmerPhotos />
    </div>
    
    <Farmer/>
    
     
     </>
  );
};

export default Dashboard;
